import CirclePlusFilled from './src/circle-plus-filled';
export default CirclePlusFilled;